module.exports = __webpack_public_path__ + "img/calendar-dot.caf71039.svg";